/**
 * Alert - inline notice primitive (shadcn-compatible: Alert / AlertTitle /
 * AlertDescription). Renders an icon slot (first child) alongside content.
 */
import React from 'react';
import { cn } from '@/lib/utils';

interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'destructive';
  children: React.ReactNode;
}

export function Alert({ variant = 'default', className, children, ...props }: AlertProps) {
  const variantClasses =
    variant === 'destructive'
      ? 'border-red-200 bg-red-50 text-red-800'
      : 'border-gray-200 bg-gray-50 text-gray-800';
  return (
    <div
      role="alert"
      className={cn('flex items-start gap-2 rounded-lg border p-3 text-sm', variantClasses, className)}
      {...props}
    >
      {children}
    </div>
  );
}

export function AlertTitle({ className, children, ...props }: React.HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h5 className={cn('mb-1 font-medium leading-none', className)} {...props}>
      {children}
    </h5>
  );
}

export function AlertDescription({ className, children, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('text-sm [&_p]:leading-relaxed', className)} {...props}>
      {children}
    </div>
  );
}
